// The UI that consumes this will not sort. The order the items are entered is the order that they are displayed.
export const changelog = [
  // !! Add new entries to the top!
  {
    title: 'Code library updates',
    date: 'November 14th 2019',
    entries: [
      'Updating libraries used to create this site. Should not affect site usability.'
    ]
  },
  {
    title: 'Saving fixes',
    date: 'August 7th 2019',
    entries: [
      'Addressed a problem that was sending empty change lists to the server'
    ]
  },
  {
    title: 'Save feedback improvements',
    date: 'August 6th 2019',
    entries: [
      'Improved visibility of the validation errors by highlighting the tabs with errors',
      'Displaying change and error counts'
    ]
  },
  {
    title: 'Portal updates',
    date: 'July 31st 2019',
    entries: [
      'Added a changelog to better share improvements, bug fixes, and other updates',
      'Added links to the Hub for reservable records'
    ]
  },
  {
    title: 'Media bug fixes',
    date: 'July 12th, 2019',
    entries: [
      'Fix issue with saving external URL when uploading images by URL',
      'Fix issue with updating existing images with a direct uploaded image',
      'Fix IsPrimary, IsPreview, IsGallery persistence issue'
    ]
  }
];
